<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue: string
    name: string
    label: string
    placeholder?: string
    disableField?: boolean
  }>(),
  {
    placeholder: undefined,
    disableField: false,
  }
)

defineEmits<{ (e: 'update:modelValue', value: string): void }>()
</script>

<template>
  <McField v-slot="{ invalid }" :name="name">
    <fieldset class="flex w-full flex-col gap-2 self-end" :class="{ 'opacity-50': disableField }">
      <legend v-if="modelValue" class="mb-1 text-2xs text-mcd-secondaryDarkGrey">
        {{ label }}
      </legend>
      <div class="relative flex w-full">
        <textarea
          :id="name"
          :value="modelValue"
          :name="name"
          class="outlinrderClasse-0 w-full border-b-2 text-mcd-black"
          :class="{ 'border-mcd-secondaryDarkGrey': !invalid, 'border-mcd-red': invalid }"
          :placeholder="placeholder"
          :disabled="disableField"
          @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
        ></textarea>
      </div>
    </fieldset>
  </McField>
</template>
